import React from "react";
import styles from "./WeekPager.module.css";
import { addDays } from "../../utils/weekDates";

// ‹ range › stepper for week-scoped pages; weekStart is a Monday as 'YYYY-MM-DD'.
export default function WeekPager({ weekStart, label, onChange, onToday }) {
  return (
    <>
      <button type="button" className={styles.pagerButton} aria-label="Previous week" onClick={() => onChange(addDays(weekStart, -7))}>‹</button>
      <span className={styles.weekRange}>{label}</span>
      <button type="button" className={styles.pagerButton} aria-label="Next week" onClick={() => onChange(addDays(weekStart, 7))}>›</button>
      {onToday && <button type="button" className={styles.pagerButton} onClick={onToday}>This week</button>}
    </>
  );
}
